
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import VueLazyload from 'vue-lazyload'

import Toast from './components/toast' // lei
import request from './utils/request' // lei


import qs from 'qs'
// import {Alert,Toast} from 'wc-messagebox'
// import 'wc-messagebox/style.css'
// Vue.use(Toast)

Vue.use(Toast) // lei

Vue.use(VueLazyload)

Vue.prototype.axios = axios


Vue.prototype.$request = request // lei


Vue.prototype.qs = qs
Vue.config.productionTip = false
Vue.config.ignoredElements = ['wx-open-launch-weapp'] //忽略wx-open-launch-weapp组件未注册
/* eslint-disable no-new */

new Vue({
  el: '#app',
  router,
  components: {
    App
  },
  template: '<App/>'
})

